<div class="row g-0" [ngClass]="{ 'bottom-border': bottomBorder }" [style]="customStyles">
  <div class="col-lg-9 offset-lg-1 col-12">
    <ng-content></ng-content>
  </div>
</div>